<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { salesReviewReturnSections } from '../composables/salesReviewReturnSections';
import SalesReviewReturnPartyCard from './SalesReviewReturnPartyCard.vue';
import SalesReviewReturnSimpleCard from './SalesReviewReturnSimpleCard.vue';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  items: { type: Array, default: () => [] },
  participants: { type: Array, default: () => [] },
  readOnly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});
const emit = defineEmits(['update:items']);
const { t } = useI18n();

const sections = computed(() => salesReviewReturnSections(t));
const itemsFor = section =>
  props.items.filter(item => item.section === section.id);
const normalizedReplacement = replacement => {
  if (Array.isArray(replacement)) return replacement;
  return replacement ? [replacement] : [];
};
const replaceSection = (section, replacement) => {
  const replacements = normalizedReplacement(replacement);
  const grouped = new Map(
    sections.value.map(definition => [
      definition.id,
      definition.id === section.id ? replacements : itemsFor(definition),
    ])
  );
  const knownSections = new Set(
    sections.value.map(definition => definition.id)
  );
  const unknownItems = props.items.filter(
    item => !knownSections.has(item.section)
  );
  emit('update:items', [
    ...sections.value.flatMap(definition => grouped.get(definition.id)),
    ...unknownItems,
  ]);
};
</script>

<template>
  <section class="grid gap-4">
    <template v-for="section in sections" :key="section.id">
      <SalesReviewReturnSimpleCard
        v-if="section.kind === 'simple'"
        :definition="section"
        :item="itemsFor(section)[0] || null"
        :options="catalog[section.id] || []"
        :read-only="readOnly"
        :show-errors="showErrors"
        @change="replaceSection(section, $event)"
      />
      <SalesReviewReturnPartyCard
        v-else
        :definition="section"
        :items="itemsFor(section)"
        :participants="participants"
        :catalog="catalog"
        :read-only="readOnly"
        :show-errors="showErrors"
        @change="replaceSection(section, $event)"
      />
    </template>
  </section>
</template>
